// Qui peut importer des œuvres en masse (CSV / Excel) : collectionneur Premium, Art Advisor Premium
// et comptes galerie. La même règle est appliquée par la fonction import_artworks_self (supabase/functions).
export const IMPORT_PLANS = ["premium", "art_advisor_premium", "advisor_premium"];

export function canUseImport(profile) {
  if (!profile) return false;
  return profile.gallery_mode === true || IMPORT_PLANS.includes(profile.plan);
}
